import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  closeButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& button': {
      paddingRight: '24px',
      paddingTop: '24px',
      [Theme.breakpoints.down('xs')]: {
        width: '80px',
      },
    },
    '& svg': {
      width: '32px',
      height: '32px',
    },
  },
  cancellationInfoWrapper: {
    padding: '0 16px',
    [Theme.breakpoints.up('lg')]: {
      padding: '0 40px',
    },
    '& h1': {
      color: Theme.palette.text.brand,
      fontSize: Theme.typography.size[7],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[9],
      },
    },
    '& p': {
      color: Theme.palette.text.body,
      fontFamily: Theme.typography.base.regular,
      lineHeight: '24px',
      marginTop: '10px',
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[1.5],
      },
    },
  },
  cancellationFeesHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '20px 0 10px',
    '& .label': {
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.text.brand,
      fontSize: Theme.typography.size[1],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[1.5],
      },
    },
  },
  cancellationFeesInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
    '& .value': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[1],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[1.5],
      },
    },
  },
}));

export default useStyles;
